import moment from 'moment';
import convert from 'convert-units';
import TimeConversionUtils from '../../lib/timeConversionUtils';
import {
  today,
  oneWeekAgo,
  twoWeeksAgo,
} from './functions';
import { averageCadence } from '../../lib/functions';

export default {
  /**
   * Returns an array with 2 elements. The first is an array of activities from two weeks ago
   * and the second is the last 7 days.
   *
   * @param state
   * @param getters
   * @returns {function(*=): *}
   */
  twoWeekActivitySplit: (state, getters) => getters.activities
    .reduce((split, activity) => {
      if (moment(activity.localStartTime).isBetween(twoWeeksAgo(), oneWeekAgo(), 'day', '[)')) {
        split[0].push(activity);
      }
      if (moment(activity.localStartTime).isBetween(oneWeekAgo(), today(), 'day', '[]')) {
        split[1].push(activity);
      }
      return split;
    }, [[], []]),

  totalDistanceKpi: (state, getters) => getters.twoWeekActivitySplit
    .reduce((lastWeek, thisWeek) => ({
      weekToDate: thisWeek.reduce((a, b) => a + b.totalDistance, 0) || 0,
      lastWeek: lastWeek.reduce((a, b) => a + b.totalDistance, 0) || 0,
    })),
  totalTimeKpi: (state, getters) => getters.twoWeekActivitySplit
    .reduce((lastWeek, thisWeek) => ({
      weekToDate: TimeConversionUtils.prettyPrintDurationHoursMinutes(thisWeek.reduce((a, b) => a + b.duration, 0)) || '-',
      lastWeek: TimeConversionUtils.prettyPrintDurationHoursMinutes(lastWeek.reduce((a, b) => a + b.duration, 0)) || '-',
    })),
  averagePaceKpi: (state, getters) => getters.twoWeekActivitySplit
    .reduce((lastWeek, thisWeek) => ({
      weekToDate:  thisWeek.reduce((a, b) => a + b.duration, 0) / thisWeek.reduce((a, b) => a + b.totalDistance, 0),
      lastWeek: lastWeek.reduce((a, b) => a + b.duration, 0) / lastWeek.reduce((a, b) => a + b.totalDistance, 0),
    })),
  powerKpi: (state, getters) => getters.twoWeekActivitySplit
    .reduce((lastWeek, thisWeek) => ({
      weekToDate: Math.round(
        thisWeek.reduce((a, b) => a.localStartTime > b.localStartTime ? a : b, {}).criticalPower,
      ) || 0,
      lastWeek: Math.round(
        lastWeek.reduce((a, b) => a.localStartTime > b.localStartTime ? a : b, {}).criticalPower,
      ) || 0,
    })),
  averageCadenceKpi: (state, getters) => getters.twoWeekActivitySplit
    .reduce((lastWeek, thisWeek) => ({
      weekToDate: averageCadence(thisWeek),
      lastWeek: averageCadence(lastWeek),
    })),
};
